import { Modal } from 'rimble-ui'
import CustomButton from '../CustomButton'
import closeIcon from '../../assets/new-ui/close-icon.svg'
import paymentIcon from '../../assets/new-ui/payment-icon.png'

export default function ModalBuyOption(props) {
  const RATE = 600
  const {toggleModal, setToggleModal, img, id, price, fn} = props

  function buyItem() {
    fn()
    setToggleModal(false)
  }

  return (
    <>
      <Modal isOpen={toggleModal}>
        <div className='customModal modalSellOption modalBuyOption'>
          <img className='closeBtn' src={closeIcon} alt='close icon' onClick={() => setToggleModal(false)} />
          <div className='nftInfo'>
            <img src={img} alt='nft sell' />
            <div>ID: {id}</div>
            <div className='payMethod'>
              <div className='payTitle'>Pay with:</div>
              <div className='payBNB'>BNB</div>
              <div className='payHLS'>HLS</div>
            </div>
          </div>
          <div className='payPrice'>
            <div className='payPriceDetail'>
              <div>{price}</div>
              <div>~ {price * RATE} USD</div>
            </div>
            <img src={paymentIcon} alt='' />
          </div>
          <div className="groupBtnSell">
            <CustomButton 
              text={'OK'}
              fn={buyItem}
              type={'medium'}
              transparent={false}
            />
          </div>
        </div>
      </Modal>
    </>
  )
}